import React, { Component } from 'react'
import { connect } from 'react-redux'

import CommentCard from './CommentCard'
import CommentForm from './CommentForm'

import { objectComments } from 'selectors/comments'

let select = (state, props) => ({
	comments: objectComments(state, props)
  , comment: state.commentBuffer
})

export class CommentList extends Component {
	render(){
		let { props } = this

		return(
			<div className="comment-list">
				{props.comments.map(comment => (props.comment.commentID != comment._id)?<CommentCard commentID={comment._id}/> : <CommentForm objectID={props.objectID} path={props.path}/>)}
			</div>
		)
	}
}

export default connect(select)(CommentList)



// WEBPACK FOOTER //
// ./src/components/Comments/CommentList.js